// API base URL. Override at build time with VITE_API_BASE.
// Defaults to localhost for dev, switch to deployed worker URL after `wrangler deploy`.
export const API_BASE =
  import.meta.env.VITE_API_BASE ??
  (location.hostname === "localhost" || location.hostname === "127.0.0.1"
    ? "http://localhost:8787"
    : "https://vroom-api.quake0day.workers.dev");

export const WS_URL = API_BASE.replace(/^http/, "ws") + "/v1/ws";
